export { default } from "./upsReceipt";
